import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import { db } from '../../firebase';
import { PDFExport } from '@progress/kendo-react-pdf';
import Breadcrumbs from '../../components/breadcrumbs';
import { Link } from 'react-router-dom';
import { average, getChartOptions, collectRadarCaptionsData } from '../../helpers';
import RadarChart from '../../components/charts/radarchart';
import LoadingState from '../../components/global/loading-state';
import withAuthorisation from '../../components/withauthorisation';
import TeamAssessmentReportPageTemplate from './teamAssessmentPageTemplate'
import Contents from '../../components/reports/Contents';
import TitlePage from '../../components/TitlePage';
import PageHeader from '../../components/PageHeader';
import DetailedFeedbackSection from '../../components/reports/detailedFeedbackSection';
import RelationshipCompetencyComparison from '../../components/charts/RelationshipCompetencyComparison';
import RankedCompetencies from '../../components/reports/RankedCompetencies';
import OrderedStatements from '../../components/reports/OrderedStatements';
import StatementVariations from '../../components/reports/StatementVariations';
import PDFExportButton from '../../components/reports/PDFExportButton';
const authCondition = (authUser) => !!authUser;

class teamReport extends Component {
  constructor(props) {
    super(props);
    this.exportPDF = this.exportPDF.bind(this);
    this.convertSVGToImage = this.convertSVGToImage.bind(this);
    this.updateCompetencyComparisonPDFExportPreRenderStatus = this.updateCompetencyComparisonPDFExportPreRenderStatus.bind(this);
    this.updateRankedCompetenciesPDFExportPreRenderStatus = this.updateRankedCompetenciesPDFExportPreRenderStatus.bind(this);
    this.updateOrderedStatementsPDFExportPreRenderStatus = this.updateOrderedStatementsPDFExportPreRenderStatus.bind(this);
    this.updateDetailedFeedbackPDFExportPreRenderStatus = this.updateDetailedFeedbackPDFExportPreRenderStatus.bind(this);

    this.state = {
      loading: true,
      error: false,
      captions: {},
      userData: {},
      userId: null,
      groupId: null,
      current360Id: null,
      current360Relationships: {'TM': { name: 'Team Members', colour: '#f563b9', description: 'Team Members consist of anyone who is part of the respective team' }},
      sectionsLegacyMode: false,
      pdfRequested: false,
      competencyComparisonPDFRenderCompleted: false,
      rankedCompetenciesPDFRenderCompleted: false,
      orderedStatementsPDFRenderCompleted: false,
      detailedFeedbackPDFRenderCompleted: false,
      layoutMode: 'default'
    };
  }
  exportPDF = () => {
    if (this.state.layoutMode !== 'pdfCompleted') {
      // triggers re-render process to split each question into pages that account for overflow
      this.setState({pdfRequested: true, layoutMode: 'pdfRecalculate'})
    }
  };
  convertSVGToImage = (htmlString) => {
    try {
      // Take an SVG html string, convert it to static markup
      let staticRadarChart = ReactDOMServer.renderToStaticMarkup(htmlString);

      // Convert SVG string into a data URI
      const svgDataUri = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(staticRadarChart)))}`;

      return svgDataUri;
    } catch (err) {
      console.log('err', err);
      return null;
    }
  };
  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    this.setState({
      userId: params.userId,
      groupId: params.groupId,
      current360Id: params.id,
    });
    db.doGetCurrentGroup(this.props.match.params.accountId, params.id, params.groupId).onSnapshot((snapshot) => {
      if (snapshot.data()) {
        const currentGroup = snapshot.data();
        const teamName = currentGroup.title.replace(' ', '-');
        const reportPdfFileName = `${teamName}-team-report.pdf`;
        db.doGetSectionsAndQuestionDetailsList(params.accountId, this.props.current360.questionnaireID).then((sections) => {
          let sectionDetails = {};
          let MultiChoiceQuestionsList = [];
          let questionDetails = {};
          let captions = {};
          let secLengthNoFreeText = {};
          let relationshipKeys = ['TM'];
          let freeTextQuestionDetails = {};
          let sectionsLegacyMode = false;

          for (const sectionID in sections) {
            const {sortOrder} = sections[sectionID];
            const questionList = sections[sectionID].questions;
            if (!secLengthNoFreeText[sectionID]) {
              secLengthNoFreeText[sectionID] = 0;
            }
            sectionDetails[sectionID] = sections[sectionID];
            if (sortOrder === undefined) {
              sectionsLegacyMode = true;
            }
            Object.keys(questionList).forEach((question) => {
              questionDetails[question] = questionList[question];
              if (questionList[question].answerType === 'MultiChoice') {
                MultiChoiceQuestionsList.push(question);
                secLengthNoFreeText[sectionID] = secLengthNoFreeText[sectionID] + 1;
                if (!captions[sectionID]) {
                  captions[sectionID] = sections[sectionID].title;
                }
              } else {
                freeTextQuestionDetails[question] = questionDetails[question]
              }
            });
          }

          // This updates state for captions, sectionDetails, radarSortedSectionIDs, numberOfRadarSections, captionKeysList
          const radarCaptionsData = collectRadarCaptionsData(captions, sectionsLegacyMode, sectionDetails);

          db.doGetCompletedReviewers(params.accountId, params.id, params.groupId, params.userId).then((snapshot) => {
            if (!snapshot.empty) {
              let reviewers = {};
              snapshot.docs.map((doc, i) => {
                reviewers[doc.id] = doc.data();
              });
              let reviewerAnswersAverageSection = {};
              let radarChartValues = {};
              let reviewerAnswersSectionArray = {};
              let reviewerAnswersAverageQuestion = {};
              let reviewerSectionResponses = {};
              let reviewerQuesionResponses = {};
              const QuestionAnswers = {};
              let reviewerData = [];
              let freeTextAnswers = {};
              for (const reviewerID in reviewers) {
                db.doGetReviewerAnswers(params.accountId, reviewerID, sections)
                  .then((data) => {
                    reviewerData.push(data);

                    Object.keys(data).forEach((sectionID) => {
                      const sectionQuestions = data[sectionID]['answers'];
                      if (!reviewerAnswersSectionArray[sectionID]) {
                        reviewerAnswersSectionArray[sectionID] = [];
                      }
                      let numberAnswersToAdd = [];
                      let textAnswersToAdd = [];
                      for (const qID in sectionQuestions) {
                        const answer = sectionQuestions[qID];
                        const type = questionDetails[qID].answerType;

                        if (type === 'MultiChoice') {
                          if (+answer > 0) {
                            numberAnswersToAdd.push(+answer);
                          }
                        } else {
                          if (!freeTextAnswers[sectionID]) {
                            freeTextAnswers[sectionID] = {};
                          }
                          if (!freeTextAnswers[sectionID][qID]) {
                            freeTextAnswers[sectionID][qID] = {'TM': []};
                          }
                          freeTextAnswers[sectionID][qID]['TM'].push(answer);
                        }
                      }
                      reviewerAnswersSectionArray[sectionID].push(...numberAnswersToAdd);
                      if (!reviewerSectionResponses[sectionID]) {
                        reviewerSectionResponses[sectionID] = [0, 0, 0, 0, 0, 0];
                      }
                      const questions = data[sectionID]['answers'];
                      if (questions) {
                        let answers = [];
                        let responses = [0, 0, 0, 0, 0, 0];
                        let answerKey = 0;
                        for (const qID in questions) {
                          if (!QuestionAnswers[qID]) {
                            QuestionAnswers[qID] = [];
                          }
                          if (!reviewerQuesionResponses[qID]) {
                            reviewerQuesionResponses[qID] = [0, 0, 0, 0, 0, 0];
                          }
                          let answerVal = isNaN(Number(questions[qID])) ? -1 : parseInt(questions[qID]);
                          if (!isNaN(parseInt(answerVal))) {
                            responses[answerVal] = responses[answerVal] + 1;
                            reviewerQuesionResponses[qID][answerVal] = reviewerQuesionResponses[qID][answerVal] + 1;
                          }
                          if (answerVal.toString() !== 'NaN') {
                            answers[answerKey] = answerVal;
                          }
                          if (answerVal > 0) {
                            QuestionAnswers[qID].push(answerVal);
                          }
                          answerKey++;
                        }
                        reviewerSectionResponses[[sectionID]].forEach((n, i) => {
                          const newResponseValue = reviewerSectionResponses[[sectionID]][i] + responses[i];
                          reviewerSectionResponses[[sectionID]][i] = newResponseValue;
                        });
                      }
                    });

                    for (const sectionID in reviewerAnswersSectionArray) {
                      const sectionAverage = average(reviewerAnswersSectionArray[sectionID]);
                      reviewerAnswersAverageSection[sectionID] = sectionAverage;
                      radarChartValues[sectionID] = sectionAverage / 5;
                    }

                    for (const qID in QuestionAnswers) {
                      reviewerAnswersAverageQuestion[qID] = average(QuestionAnswers[qID]);
                    }

                    return Promise.resolve();
                  })
                  .then(() => {
                    if (reviewerData.length === Object.keys(reviewers).length) {
                      const weightedHighest = [];
                      Object.entries(reviewerAnswersAverageQuestion)
                        .sort((a, b) => b[1] - a[1])
                        .forEach((q) => {
                          if (q[1] > 0) {
                            if (!weightedHighest.includes(q[0])) {
                              weightedHighest.push(q[0]);
                            }
                          }
                        });
                      this.setState({
                        freeTextAnswers,
                        reviewerSectionResponses,
                        reviewerQuesionResponses,
                        radarChartValues,
                        reviewerAnswersAverageSection,
                        reviewerAnswersAverageQuestion,
                        weightedHighest,
                        sectionDetails,
                        questionDetails,
                        freeTextQuestionDetails,
                        captions,
                        generateGraph: MultiChoiceQuestionsList.length > 0 ? true : false,
                        secLengthNoFreeText,
                        currentGroup,
                        relationshipKeys,
                        reportPdfFileName,
                        sectionsLegacyMode,
                        ...radarCaptionsData,
                        loading: false,
                      });
                    }
                  });
              }
            }
          });
        });
      }
    });
  }
  componentDidUpdate(prevProps, prevState) {
    // run initial updates for pdfRenderCompleted when the both the radar chart captions and detailed feedback sections are finished
    if (
        !this.state.pdfRenderCompleted &&
        (
          (prevState.competencyComparisonPDFRenderCompleted !== this.state.competencyComparisonPDFRenderCompleted) 
          || 
          (prevState.rankedCompetenciesPDFRenderCompleted !== this.state.rankedCompetenciesPDFRenderCompleted)
          ||
          (prevState.orderedStatementsPDFRenderCompleted !== this.state.orderedStatementsPDFRenderCompleted)
          ||
          (prevState.detailedFeedbackPDFRenderCompleted !== this.state.detailedFeedbackPDFRenderCompleted) 
        )
      ) {
        if (
          this.state.competencyComparisonPDFRenderCompleted 
          && this.state.rankedCompetenciesPDFRenderCompleted 
          && this.state.orderedStatementsPDFRenderCompleted
          && this.state.detailedFeedbackPDFRenderCompleted
        ) {
          this.setState({ layoutMode: 'PDFRender' })
        }
      } else if (this.state.layoutMode === 'PDFRender') {
        const saveReport = async () => {
          await this.report.save();
          this.setState({layoutMode: 'pdfCompleted'})
          return;
        }
        saveReport();
      }
  }
  updateCompetencyComparisonPDFExportPreRenderStatus() {
    this.setState({competencyComparisonPDFRenderCompleted: true})
  }
  updateRankedCompetenciesPDFExportPreRenderStatus() {
    this.setState({rankedCompetenciesPDFRenderCompleted: true})
  }
  updateOrderedStatementsPDFExportPreRenderStatus() {
    this.setState({orderedStatementsPDFRenderCompleted: true})
  }
  updateDetailedFeedbackPDFExportPreRenderStatus() {
    this.setState({detailedFeedbackPDFRenderCompleted: true})
  }
  render() {
    const {generateGraph, relationshipKeys, current360Relationships, sectionsLegacyMode, sectionDetails, pdfRequested, radarSortedSectionIDs, captionKeysList, layoutMode} = this.state;
    if (!this.state.loading) {
      let data = [{ data: this.state.radarChartValues, meta: { color: '#F563B9' } }];
      const captionsLoaded = this.state.captions;

      const chartOptions = getChartOptions(captionsLoaded, radarSortedSectionIDs, 14);

      const reviewerAnswersAverageSection = this.state.reviewerAnswersAverageSection;
      const reviewerAnswersAverageQuestion = this.state.reviewerAnswersAverageQuestion;

      return (
        <div className='page-wrapper page-wrapper--report'>
          <section className='container container--slim'>
            <Breadcrumbs
              current360={this.props.current360}
              accountData={this.props.accountData}
              current360Groups={this.props.current360Groups}
              current360Relationships={this.props.current360Relationships}
              links={[
                {
                  title: 'Dashboard',
                  to: `/dashboard/${this.props.match.params.accountId}`,
                },
                {
                  title: `${this.props.accountData.accountTitle ? this.props.accountData.accountTitle : this.props.accountData.title} ${
                    this.props.current360.type
                  } Projects`,
                  to: `../../../../../../../team-assessment-projects/`,
                },
                {
                  title: this.props.current360.title,
                  to: '../../../../',
                },
                {
                  title: this.state.currentGroup.title,
                  // to: `../../../edit/group/${this.state.groupId}/`,
                  to: `../../`,
                },
                {
                  title: `Report & Development plan for ${this.state.userFullName}`,
                  to: null,
                },
              ]}
            />
          </section>
          <div
            className='user-report-view-only'
            style={{ height: '100vh', width: '100vw', paddingTop: 20, paddingBottom: 100, backgroundColor: 'rgb(82, 86, 89)', overflow: 'hidden' }}
          >
            <div className='tc' style={{ marginBottom: '1.4em' }}>
              <Link className='btn btn--back btn--white ml2 mr3' to={`../../`}>
                Back to group overview
              </Link>
              <PDFExportButton pdfRequested={pdfRequested} layoutMode={layoutMode} exportFunction={this.exportPDF} />
            </div>
            <div
              style={{
                maxWidth: '210mm',
                height: '90vh',
                backgroundColor: 'white',
                boxShadow: '0px 0px 5px #000',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginBottom: 100,
                padding: '0px',
                overflowX: 'scroll',
                overflowY: 'scroll',
              }}
            >
              <PDFExport
                paperSize={'A4'}
                forcePageBreak='.page-break'
                keepTogether={'div'}
                margin={{ bottom: 50 }}
                pageTemplate={TeamAssessmentReportPageTemplate}
                fileName={this.state.reportPdfFileName}
                title=''
                subject=''
                keywords=''
                ref={(r) => (this.report = r)}
              >
                <div
                  className='user-report'
                  style={{
                    height: '100%',
                    width: '100%',
                    padding: '0px',
                  }}
                >
                  <header className='user-report__header'>
                    <img crossOrigin='anonymous' src={this.props.current360.settings.logo} className='header-logo-img' />
                    <div className='w-80'>
                      <h1 className='user-report__header-title'>{this.props.current360.title}</h1>
                      <p className='user-report__header-sub-title'>
                        <strong>Team Assessment Report</strong>
                      </p>
                      <p className='user-report__header-name'>For {this.state.currentGroup.title}</p>
                    </div>
                  </header>

                  {/* <Contents partTitles={['Team feedback summary', 'Team Detailed Feedback', 'Free text feedback']} /> */}
                  <Contents partTitles={['Team feedback summary', 'Team Detailed Feedback']} />

                  <TitlePage h2Text='Introduction' />

                  <div className='bg-white user-report__content'>
                    <PageHeader h2Class='mt4' h2Text={<strong>Introduction</strong>} h3Text='Getting the most from team feedback' line={true} />
                    <h3 className='f5 mt4'>
                      <strong>Where to begin?</strong>
                    </h3>
                    <p>
                      It’s a good idea to read the report in the order provided. However, you may prefer to dive into a specific section and then pull out
                      related information from other parts of the report. You can see how the different elements of the report relate to each other, in the
                      section ‘How your report is compiled’.
                    </p>
                    <h3 className='f5 mt4'>
                      <strong>Look for consistent messages</strong>
                    </h3>
                    <p>
                      The key to understanding the team feedback is to look for clear and consistent themes across your report. Look for competencies and
                      statements where team members have given similar ratings or comments. These consistent themes will provide an indication of where the
                      team's strengths, or opportunities for improvements, can be found.
                    </p>
                    <p>
                      You should interpret one-off or isolated ratings or comments carefully. If you do find these, consider the context in which they may have
                      been provided. Ask yourself if there is any truth in these findings, or if they can be classified as ‘outliers’?
                    </p>
                    <PageHeader
                      containerClass='page-break'
                      h2Class='mt4'
                      h2Text={<strong>Introduction</strong>}
                      h3Text='How your report is compiled'
                      line={true}
                    />
                    <h3 className='f5 mt4'>
                      <strong>Two things to note</strong>
                    </h3>
                    <p>The feedback is made up of two key elements: competencies and statements.</p>
                    <h3 className='f5 mt4'>
                      <strong>Competencies</strong>
                    </h3>
                    <p>Competencies are high-level collections/groups of skills or knowledge. Each competency is made up of a series of statements.</p>
                    <h3 className='f5 mt4'>
                      <strong>Statements</strong>
                    </h3>
                    <p>Statements are a series of actions or behaviours, which are used to describe each competency area.</p>
                    <h3 className='f5 mt4'>
                      <strong>Rating calculations</strong>
                    </h3>
                    <p>
                      When completing the online questionnaire, team members rated each statement against a rating scale. These ratings are collated and
                      averaged to show the mean rating for each statement, and for each of the overall competencies.
                    </p>
                    <h3 className='f5 mt4'>
                      <strong>Unable to comment rating</strong>
                    </h3>
                    <p>
                      There are occasions where some team members may feel unable to provide feedback to a specific statement. In these instances, they might
                      have selected the ‘unable to comment’ rating.
                    </p>
                    <p>
                      Whenever the reviewer chooses this rating, it is not included in the rating calculation for that statement, or in the overall competency
                      rating.
                    </p>
                  </div>

                  {/* part 1 step 1 */}
                  <RelationshipCompetencyComparison
                    reportType='Team'
                    generateGraph={generateGraph}
                    completedRelationshipIDs={relationshipKeys}
                    current360Relationships={current360Relationships}
                    chartOptions={chartOptions}
                    captionsLoaded={captionsLoaded}
                    data={data}
                    convertSVGToImage={this.convertSVGToImage}
                    orderedSectionIDs={radarSortedSectionIDs}
                    numberOfSections={radarSortedSectionIDs.length}
                    pdfRequested={pdfRequested}
                    sectionDetails={sectionDetails}
                    captionKeysList={captionKeysList}
                    updateCompetencyComparisonPDFExportPreRenderStatus={this.updateCompetencyComparisonPDFExportPreRenderStatus}
                    layoutMode={layoutMode}
                  />

                  {/* Part 1 Step 2 */}
                  <RankedCompetencies
                    reportType='Team'
                    generateGraph={generateGraph}
                    answerKeys={Object.keys(reviewerAnswersAverageSection)}
                    sectionDetails={sectionDetails}
                    reviewerAnswersAverage={reviewerAnswersAverageSection}
                    updateRankedCompetenciesPDFExportPreRenderStatus={this.updateRankedCompetenciesPDFExportPreRenderStatus}
                    pdfRequested={pdfRequested}
                    layoutMode={layoutMode}
                  />

                  {/* Part 1 Step 3 */}
                  <OrderedStatements
                    reportType='Team'
                    generateGraph={generateGraph}
                    weightedHighest={this.state.weightedHighest}
                    reviewerAnswersAverages={reviewerAnswersAverageQuestion}
                    questionDetails={this.state.questionDetails}
                    updateOrderedStatementsPDFExportPreRenderStatus={this.updateOrderedStatementsPDFExportPreRenderStatus}
                    pdfRequested={pdfRequested}
                    layoutMode={layoutMode}
                  />

                  {/* Part 2 */}
                  <DetailedFeedbackSection
                    loading={this.state.loading}
                    reportType='Team'
                    sectionDetails={this.state.sectionDetails}
                    questionDetails={this.state.questionDetails}
                    freeTextQuestionDetails={this.state.freeTextQuestionDetails}
                    current360Relationships={this.state.current360Relationships}
                    sectionAveragesByRelationshipCurrent={{'TM': this.state.reviewerAnswersAverageSection}}
                    sectionResponsesByRelationshipCurrent={{'TM': this.state.reviewerSectionResponses}}
                    questionAveragesByRelationshipCurrent={{'TM': this.state.reviewerAnswersAverageQuestion}}
                    questionResponsesByRelationshipCurrent={this.state.reviewerQuesionResponses}
                    reviewerFreetextResponses={this.state.freeTextAnswers}
                    dfSectionRelationshipKeys={this.state.relationshipKeys}
                    relationshipKeys={this.state.relationshipKeys}
                    pdfRequested={this.state.pdfRequested}
                    updateDetailedFeedbackPDFExportPreRenderStatus={this.updateDetailedFeedbackPDFExportPreRenderStatus}
                    layoutMode={layoutMode}
                  />

                  {/* Ending */}
                  <header className='page-break user-report__header'>
                    <img crossOrigin='anonymous' src={this.props.current360.settings.logo} className='header-logo-img' />
                    <div className='w-80'>
                      <h1 className='user-report__header-title'>Good Luck</h1>
                      <p className='user-report__header-sub-title'>
                        <strong>Own the change you want to see! </strong>
                      </p>
                    </div>
                  </header>
                </div>
              </PDFExport>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          {this.state.error ? (
            <div className='error-404 bg-blue fixed left-0 top-0'>
              <h1 className='white mt4'>System Error - Error loading report</h1>
            </div>
          ) : (
            <LoadingState />
          )}
        </div>
      );
    }
  }
}

export default withAuthorisation(authCondition)(teamReport);
